export default __webpack_public_path__ + "static/media/existing-prospect.27f8b097.svg";